// extracted by mini-css-extract-plugin
export default {"container":"style_container__dk3Pd","loadingWrapper":"style_loadingWrapper__xkm4C","contentWrapper":"style_contentWrapper__vx2N7"};